import angular from 'angular';

export const AnchorDirectiveModule = angular.module('acme.common.directive.a', []).directive('a', [
  function () {
    return {
      restrict: 'E',
      link: function ($scope, $element, $attrs) {
        init();

        function init() {
          /**
           * This directive acts globally and we need a way to opt-out since it's conflicting
           * the `json-formatter` directive.
           */
          const shouldBeIgnored = $element.closest('[acmeIgnoreAnchor]').length;

          if (shouldBeIgnored) {
            return;
          }

          // if anchor is inside ui-grid, tabindex -1
          // if achor have noTabbing, tabindex -1
          if ($attrs.hasOwnProperty('noTabbing')) {
            $element.attr('tabindex', '-1');
          } else {
            const attr: any = {};
            const role = 'button';
            const href = $attrs.href ? $attrs.href : '#'; // adding # makes <a> clickable from keyboard
            const tabindex = $attrs.tabindex ? $attrs.tabindex : 0; // maybe someone set -1 on purpose

            if (href === '#') {
              attr.role = role;
              attr.href = '';
            }

            attr.tabindex = tabindex;

            $element.attr(attr);
          }

          $element.on('click', function (event) {
            if ($attrs.href === '#') {
              event.preventDefault(); // prevents from adding # to url
            }
          });
        }
      },
    };
  },
]).name;
